import { reportWebSession } from './reportWebSession';

interface IAnalytics {
  reportWebSession: typeof reportWebSession;
}

/**
 * @namespace
 */
const Analytics: IAnalytics = {
  reportWebSession,
};

export default Analytics;
